import './../css/mk-brand.css';

import React, {useState, useEffect} from 'react';
import {useConnection, useWallet} from '@solana/wallet-adapter-react';
import {getNftsFromWallet} from '../candy-utils';
import Nft from '../components/nft-control';
import Toast from '../components/toast-control';
import config from '../config';
import {gPageView} from "../google-analytics";
import {HashLink as Link} from "react-router-hash-link";

function MyKitchenPage() {
  const wallet = useWallet();
  const {connection} = useConnection();
  const [isMinting, setIsMinting] = useState(false);
  const [myOgChefs, setMyOgChefs] = useState();
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    severity: undefined,
  });

  useEffect(() => {
    gPageView('my-kitchen');
    (async () => {
      if (wallet) {
        await onGetAccountInfo();
      }
    })();
  }, [wallet, connection]);

  const onGetAccountInfo = async () => {
    setIsMinting(true);
    try {
      if (wallet && wallet.connected) {
        setAlertState({
          open: false,
          message: '',
          severity: 'info',
        });
        const ogChefs = await getNftsFromWallet(
            connection,
            config.OG_CHEFS_CANDY_MACHINE_ID,
            wallet.publicKey);
        ogChefs.sort((a,b) => {
              const aid = parseInt(a.json.name.substring(9));
              const bid = parseInt(b.json.name.substring(9));
              return aid - bid;
            })
        setMyOgChefs(ogChefs);
      } else {
        setAlertState({
          open: true,
          message: 'Please connect your wallet to see your chefs.',
          severity: '',
        });
      }

    } catch (error) {

      let message = error.msg || 'Could not access your wallet. Please try again.';
      if (!error.msg) {
        if (error.message.indexOf('0x138')) {
        } else if (error.message.indexOf('0x137')) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: 'danger',
      });
    } finally {
      setIsMinting(false);
    }
  };

  return (
    <div id="my-kitchen-page" className="panel">
      <div className="max-w-lg w-full">
        <Toast
          open={alertState.open}
          message={alertState.message}
          severity={alertState.severity}
          onClose={() => setAlertState({...alertState, open: false})}
        />
      </div>

      {isMinting ? (
        <div className="max-w-5xl rounded-lg border m-2 p-2">
          <span>Checking your wallet ...</span>&nbsp;&nbsp;
          <svg className="animate-spin h-5 w-5 mr-3 inline" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
            <path className="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
          </svg>
        </div>
      ) : null}
      <div className="panel container bg-zinc-800 pt-4 px-4 pb-4 max-w-7xl">
      <h1 className="text-3xl">Your OG Chefs</h1>
      {myOgChefs ? <div className="max-w-7xl flex flex-row flex-wrap justify-items-center align-middle">{
        myOgChefs.map(nft => {
          return <Nft nft={nft}/>;
        })
      }</div> : null}
      </div>

    </div>
  );
}

export default MyKitchenPage;
